/** The arrow keeps at least this far from the tooltip's ends. */
export const TOOLTIP_ARROW_PADDING = 4;
